import { toTotalCredits } from "../helpers/toTotalCredits";
import { useMyUser } from "./useMyUser";

export function useMyUserTotalCredits() {
  return useMyUser((state) => toTotalCredits(state.user));
}
